/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import moment from 'moment';
import { CloseIcon, StarActiveIcon, UserIcon } from 'assets/icons';
import { Globals } from 'utils';
import { ReportsService } from 'services';
import { FallbackImage, Input } from 'components';

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

interface ModalViewCommentsProps {
  user?: any
  onClose: () => void
}

const initialForm = {
  id: 0,
  search: '',
};

class ModalViewComments extends React.Component<ModalViewCommentsProps> {

  state = {
    form: {
      ...initialForm,
      id: this.props.user?.id,
    },
    pagination: {
      page: 1,
      pages: 1,
    },
    data: [],
  }

  debounce?: NodeJS.Timeout;

  componentDidMount() {
    this.getData();
  }

  getData = async (page = 1) => {
    try {
      const res = await ReportsService.doctorComments({ ...this.state.form, page });
      const { data, ...rest } = res as any;

      this.setState({
        data: data,
        pagination: rest,
      });

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  change = async (value: string | number | boolean, target: keyof typeof initialForm) => {
    const form = Globals.clone(this.state.form);
    form[target] = value;
    await this.setState({ form });

    if (this.debounce) clearTimeout(this.debounce);
    this.debounce = setTimeout(async () => this.getData(), 800);
  }

  canCleanFilters = () => {
    return !!this.state.form.search;
  }

  render() {
    const { data, form } = this.state;
    return (
      <div>
        <button className="close-btn" onClick={this.props.onClose}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>

        <section className="head">
          <div className="doctor-photo-wrapper">
            <img
              className="doctor-photo"
              src={Globals.fromPhotos(this.props.user?.photo)}
              onError={e => {
                e.currentTarget.src = UserIcon;
                e.currentTarget.classList.remove('doctor-photo');
                e.currentTarget.classList.add('doctor-photo-placeholder');
              }}
              alt="Foto de doctor"
            />
          </div>
          <div>
            <p className="name">{ this.props.user?.full_name }</p>
            <div className="rating">
              {[...Array(Math.floor(this.props.user?.rating || 0))].map((el) => (
                <img src={StarActiveIcon} alt="rating" />
              ))}
            </div>
          </div>
        </section>

        <div className="filters">
          <Input
            placeholder="Buscar paciente"
            value={form.search}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'search')}
          />
        </div>

        <section className="body">
          {data?.map((appointment: any, index: number) => (
            <div key={index} className="item">
              <div className="top">
                <div className="patient">
                  <div className="user-photo-wrapper">
                    <FallbackImage
                      src={appointment?.user?.photo}
                      placeholder={UserIcon}
                      className="user-photo"
                      placeholderClassName="user-photo-placeholder"
                    />
                  </div>

                  <div>
                    <p className="name">{ appointment?.user?.full_name }</p>
                    <p className="document">{ appointment?.user?.full_document }</p>
                  </div>
                </div>

                <p className="date">{ moment(appointment?.date).format('DD-MM-YYYY') }</p>
              </div>

              <div className="ratings">
                <p className="name">Calificación</p>
                <div className="rating">
                  {[...Array(Math.floor(appointment?.rating?.rating || 0))].map((el) => (
                    <img src={StarActiveIcon} alt="rating" />
                  ))}
                </div>
              </div>

              <div className="comments">
                {appointment?.comments?.map((comment: any) => (
                  <div key={`comment-${comment?.id}`} className="comment">
                    <p className="item-question">{ comment?.question?.question }</p>
                    <p className="item-response">- { comment?.answer?.label || comment?.response }</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </section>
      </div>
    );
  }
}

export default ModalViewComments;